import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay } from '../../../../../../constants/helpers/dates';

import { CustomerEnrollmentBillingFilters } from './interfaces';

export const CUSTOMER_ENROLLMENT_PROVIDERS = ['FBN_USSD'];

export const initFilters: CustomerEnrollmentBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.TO]: 'now',
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.STATUS]: [],
  [FILTERS.CUSTOMER_MSISDN]: [],
  [FILTERS.PROVIDER_NAME]: []
};

export const activeFiltersCountMapper = (activeFilters: CustomerEnrollmentBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.status?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.customer_msisdn?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.provider_name?.length > 0) {
    availableFiltersCount += 1;
  }

  return availableFiltersCount;
};
